/**
 * Bexxly Cart Watcher — Global Asset
 * Upload to: shopify/assets/bexxly-cart-watcher.js
 *
 * Removes free-gift line items whose parent has been removed from cart.
 * Works on every page (cart, checkout step 1, drawer, etc.) because it is
 * loaded from theme.liquid — not from the product-hero section.
 *
 * Guard: window.__bxCartWatcher prevents double-init if the tag is
 * accidentally included more than once.
 */
(function () {
  'use strict';

  if (window.__bxCartWatcher) return;
  window.__bxCartWatcher = true;

  /* ── Debounce: prevents rapid back-to-back fetches ── */
  var _debTimer = null;
  function debounce(fn, ms) {
    clearTimeout(_debTimer);
    _debTimer = setTimeout(fn, ms);
  }

  /* ── Lock: prevents re-entry while a /cart/update.js call is in-flight ── */
  var _running = false;

  /* ── Core: fetch cart → find orphan gifts → remove them ── */
  function removeOrphans() {
    if (_running) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];

        /* 1. Collect every _parent_id that belongs to a real (non-gift) item */
        var liveParents = {};
        items.forEach(function (item) {
          var pid       = item.properties && item.properties['_parent_id'];
          var isGift    = item.properties && item.properties['_free_gift'] === 'true';
          if (pid && !isGift) liveParents[String(pid)] = true;
        });

        /* 2. Mark any gift whose parent is gone */
        var updates = {};
        var dirty   = false;
        items.forEach(function (item) {
          var pid    = item.properties && item.properties['_parent_id'];
          var isGift = item.properties && item.properties['_free_gift'] === 'true';
          if (isGift && pid && !liveParents[String(pid)]) {
            updates[item.key] = 0;
            dirty = true;
          }
        });

        if (!dirty) return;

        /* 3. Remove orphans */
        _running = true;
        return fetch('/cart/update.js', {
          method:      'POST',
          credentials: 'same-origin',
          headers:     { 'Content-Type': 'application/json' },
          body:        JSON.stringify({ updates: updates })
        })
          .then(function (r) { return r.json(); })
          .then(function (resp) {
            _running = false;
            /* Notify theme cart UI — fire both common event names */
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: resp }));
            if (typeof window.manualCartRefresh === 'function') window.manualCartRefresh(resp);
          })
          .catch(function (err) {
            _running = false;
            console.error('[Bexxly] removeOrphans update error:', err);
          });
      })
      .catch(function (err) {
        console.error('[Bexxly] removeOrphans fetch error:', err);
      });
  }

  /* Debounced wrapper used by all triggers */
  function scheduleCheck(delay) {
    debounce(removeOrphans, delay || 500);
  }

  /* ── Theme event hooks (Horizon + common third-party themes) ── */
  [
    'cart:item:removed',
    'cart:change',
    'cart:refresh',       // Note: removeOrphans dispatches cart:updated (different name) — no loop
    'sections:render',
  ].forEach(function (ev) {
    document.addEventListener(ev, function () { scheduleCheck(400); });
  });

  /* ── Fallback: intercept remove-button clicks ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      '[data-action="remove-item"], ' +
      '.cart-item__remove, ' +
      '.js-remove-item, ' +
      'button[data-line], ' +
      '[data-cart-remove], ' +
      '.cart__remove'
    );
    if (btn) {
      scheduleCheck(600);
      scheduleCheck(1400); /* second pass for slow themes */
    }
  });

  /* ── MutationObserver: watches the live cart DOM for removed nodes ── */
  function attachObserver() {
    var selectors = [
      'cart-items-component',
      '[id*="CartItems"]',
      '[id*="cart-items"]',
      '.cart-items',
      '.cart__items',
      '[data-cart-items]'
    ];
    var root = null;
    for (var i = 0; i < selectors.length; i++) {
      root = document.querySelector(selectors[i]);
      if (root) break;
    }
    if (!root) return;

    new MutationObserver(function (mutations) {
      var hadRemoval = mutations.some(function (m) { return m.removedNodes.length > 0; });
      if (hadRemoval) scheduleCheck(400);
    }).observe(root, { childList: true, subtree: true });
  }

  /* Re-run observer attachment whenever Shopify re-renders a section */
  document.addEventListener('shopify:section:load', attachObserver);
  document.addEventListener('sections:render',      attachObserver);

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      attachObserver();
      removeOrphans(); /* clean up any orphans already in cart on page load */
    });
  } else {
    attachObserver();
    removeOrphans();
  }

})();